import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue'
import { ValidationRule } from 'vee-validate/dist/types/types'

import LDialog from '@/global-components/LDialog.vue'

interface LTextPromptProps {
  title: string
  placeholder: string
  rules: ValidationRule[]
  defaultValue?: string
  closeOnSave?: boolean
  uppercase?: boolean
  content?: string
  action?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LTextPrompt',
  props: {
    title: null,
    placeholder: null,
    rules: null,
    defaultValue: { default: '' },
    closeOnSave: { type: Boolean, default: true },
    uppercase: { type: Boolean, default: false },
    content: { default: undefined },
    action: { default: undefined }
  },
  emits: ["save"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: 'save', value: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { title: string, placeholder: string, rules: ValidationRule[], defaultValue: string, closeOnSave: boolean, uppercase: boolean, content: string, action: string };





expose({ toggleDialog })

const lDialog = ref<LDialog>()
const form = ref<HTMLFormElement>()

const inputValue = ref(props.defaultValue)
const isValidValue = ref(true)

watch(() => props.defaultValue, resetForm)
function resetForm() {
  inputValue.value = props.defaultValue
  form.value?.resetValidation()
}

function saveValue(): void {
  emit('save', inputValue.value)

  if (props.closeOnSave) {
    toggleDialog()
  }
}

function toggleDialog(): void {
  lDialog.value?.toggleDialog()
}

return { __sfc: true,props, emit, lDialog, form, inputValue, isValidValue, resetForm, saveValue, toggleDialog, LDialog }
}

})